export const API_BASE_URL = "https://stage-api.myanmardoe.com"
// export const API_BASE_URL = `http://192.168.1.166:3001`
// export const API_BASE_URL = `http://192.168.1.124:3001`
// export const API_BASE_URL = `http://localhost:3001`
export const ImageUrl = "https://doe-asserts.s3.ap-southeast-1.amazonaws.com/"

